import React, { useEffect, useState } from 'react';

interface HourlyRateInputProps {
  value: number;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  title?: string;
}

// Allows up to two digits after the decimal point; keeps raw text while typing
// so inputs like "12." are not collapsed by number parsing.
const HourlyRateInput: React.FC<HourlyRateInputProps> = ({ value, onChange, ...rest }) => {
  const [text, setText] = useState(String(value));

  useEffect(() => {
    // Sync from outside only when the numeric value differs from what is typed
    if (parseFloat(text) !== value && !(text === '' && value === 0)) {
      setText(String(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <input
      type="number"
      min="0"
      step="0.01"
      value={text}
      onChange={(e) => {
        const next = e.target.value;
        if (!/^\d*(\.\d{0,2})?$/.test(next)) return;
        setText(next);
        onChange(next);
      }}
      onBlur={() => setText(Number.isNaN(parseFloat(text)) ? '0.00' : parseFloat(text).toFixed(2))}
      {...rest}
    />
  );
};

export default HourlyRateInput;
